import React, {useContext, useState} from "react";
import {useNavigation} from "@react-navigation/native";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {View} from "react-native";
import TextM from "@common/components/text/TextM";
import TextButtonM from "@common/components/button/TextButtonM";
import {TutorNextEventsModal} from "./TutorNextEventsModal";
import {theme} from "@common/theme/theme";

export const TutorNextEventsCard = (props) => {
    const {data, renderItem, title} = props;

    const [modal, setModal] = useState(false);
    const navigation = useNavigation();
    const handleShowModal = () => setModal(!modal);

    const tab = data?.slice(0, 3);

    let dimensions = useContext(DimensionsContext);

    return (
        <View
            style={{
                // flex: 1,
                // marginTop: 30,
                paddingHorizontal: 20,
                paddingVertical: 20,
                width: dimensions?.width,
            }}
        >
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <TextM fontWeight={"Bold"} color={theme.colors.primary} fontSize={20}>
                    {title}
                </TextM>

                {data?.length > 0 && <TextButtonM
                    onPress={() => handleShowModal()}
                    style={{}}
                    fontWeight={"Bold"}
                    label="VOIR TOUS"
                />}
            </View>
            {(!data || data?.length === 0) && (
                <>
                    <View>
                        <TextM style={{marginTop: 10}}>Aucun élément</TextM>
                    </View>
                </>
            )}

            {data?.length > 0 && (
                <View
                    style={{
                        flexDirection: dimensions?.width > 800 ? "row" : "column",
                        flexWrap: "wrap",
                        alignItems: "stretch",
                    }}
                >
                    {tab?.map((item, key) => {
                        return renderItem(item, key);
                    })}
                </View>
            )}
            <TutorNextEventsModal
                isOpen={modal}
                data={data}
                handleShowModal={handleShowModal}
                renderItem={renderItem}
                title={title}
                navigation={navigation}
            />
        </View>
    );
};
